import { createFileRoute, useNavigate, useSearch } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import { Button } from "@patient-watch/ui";
import { useCopy } from "../../i18n/locale";

export const Route = createFileRoute("/form/")({
    component: EntryCheckComponent,
});

function EntryCheckComponent() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { entry_id, profile_id } = useSearch({ from: "/form/" });
    const copy = useCopy().formShell;

    const handleNext = () => {
        navigate({
            to: "/form/at-sea",
            search: { entry_id, profile_id },
        });
    };

    const handleSeeEntries = () => {
        if (!profile_id) return;
        queryClient.invalidateQueries({
            queryKey: ["profile-entries", profile_id],
        });
        navigate({
            to: "/entries",
            search: { profile_id },
        });
    };

    return (
        <div className="flex flex-col gap-3">
            <Button onClick={handleNext} className="w-full" size="lg">
                {copy.start}
            </Button>
            <Button onClick={handleSeeEntries} className="w-full" size="lg" variant="outline" disabled={!profile_id}>
                {copy.seeEntries}
            </Button>
        </div>
    );
}
